const StudentManagementRoutes = (prop) => [
    {
        path: 'student-profile',
        name: prop + '.student_profile',
        meta: { auth: true },
        component: () => import('../pages/student-profile/List.vue')
    },
    {
        path: 'student-attendance',
        name: prop + '.student_attendance',
        meta: { auth: true },
        component: () => import('../pages/student-attendance/List.vue')
    },
    {
        path: 'hostel-assign',
        name: prop + '.hostel_assign',
        meta: { auth: true },
        component: () => import('../pages/hostel-assign/List')
    },
    {
        path: 'individual-education-plan',
        name: prop + '.individual-education-plan',
        meta: { auth: true },
        component: () => import('../pages/plan-assign/List')
    },
    {
        path: 'individual-education-plan-add',
        name: prop + '.individual-education-plan-add',
        meta: { auth: true },
        component: () => import('../pages/plan-assign/Form'),
        props: true
    },
    {
        path: 'parent-training',
        name: prop + '.parent_training',
        meta: { auth: true },
        component: () => import('../pages/parent-training/List')
    },
    {
        path: 'student-drop-release',
        name: prop + '.student-drop-release',
        meta: { auth: true },
        component: () => import('../pages/student-drop-release/List')
    },
    {
        path: 'student-therapy-management',
        name: prop + '.student_therapy_management',
        meta: { auth: true },
        component: () => import('../pages/student-therapy-management/List')
    },
    {
        path: 'class-promotion',
        name: prop + '.class_promotion',
        meta: { auth: true },
        component: () => import('../pages/class-promotion/List')
    },
    {
        path: 'individual-assessment',
        name: prop + '.individual_assessment',
        meta: { auth: true },
        component: () => import('../pages/individual-assessment/List')
    },
    {
        path: 'individual-assessment-entry',
        name: prop + '.individual_assessment_entry',
        meta: { auth: true },
        props: true,
        component: () => import('../pages/individual-assessment/Form')
    }
]
const routes = [{
    path: '/disability-school-service/student-management',
    name: 'disability_school_service.student_management',
    component: () => import('@/layouts/DisabilitySchoolLayout.vue'),
    meta: { auth: true },
    children: StudentManagementRoutes('disability_school_service.student_management')
}]
export default routes
